export default __webpack_public_path__ + "static/media/2.77d06e32.webp";